
import React from "react";

const HeurekkaChildSafetyPolicy = () => {
  return (
    <div className="policy-container">
      <style>
        {`
          .policy-container {
            max-width: 800px;
            margin: 20px auto;
            padding: 20px;
            font-family: Arial, sans-serif;
            background: #f9f9f9;
            border-radius: 8px;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
          }
          h1, h2 {
            color: #333;
          }
          p, li {
            color: #555;
            line-height: 1.6;
          }
          ul {
            margin-left: 20px;
          }
          .contact {
            margin-top: 20px;
            font-weight: bold;
          }
        `}
      </style>
      <h1>Heurekka Child Safety Standards and Protection Policy</h1>
      <p><strong>Last Updated: 31/01/2024</strong></p>
      <p>
        At Heurekka, we are committed to creating a safe and collaborative
        environment for developers, designers, and creatives to share and
        engage. As part of our commitment, we maintain strict policies and
        guidelines to prevent any misuse of our platform, particularly with
        regards to safeguarding children and combating child sexual abuse and
        exploitation (CSAE).
      </p>
      <h2>1. Prohibited Content and Behavior</h2>
      <p>Heureka strictly prohibits any form of child sexual abuse material (CSAM), exploitation, or harmful content, including:</p>
      <ul>
        <li>Any images, videos, or media depicting child abuse or exploitation.</li>
        <li>Solicitation or grooming of minors.</li>
        <li>Sharing or linking to inappropriate or harmful material.</li>
        <li>Harassment, bullying, or predatory behavior targeting minors.</li>
      </ul>
      <p>Violations will result in immediate content removal, account suspension, and possible reporting to law enforcement.</p>
      
      <h2>2. Content Moderation and Reporting Mechanisms</h2>
      <ul>
        <li><strong>Manual Content Reviews:</strong> All content is subject to manual review by our moderation team.</li>
        <li><strong>User Reporting:</strong> Users can report inappropriate content or behavior via Heurekka Support or the "Report a Bug/Feedback" feature.</li>
        <li><strong>Review and Action:</strong> Reports are reviewed within 24 hours, with necessary actions taken.</li>
      </ul>
      
      <h2>3. Age Restrictions and Account Controls</h2>
      <ul>
        <li>Not intended for children under 13.</li>
        <li>Users between 13 and 18 should use the platform under parental guidance.</li>
        <li>Potential age verification measures may be implemented.</li>
      </ul>
      
      <h2>4. Data Privacy and Security</h2>
      <p>Heureka is working towards compliance with child-focused data privacy laws such as COPPA and GDPR-K.</p>
      
      <h2>5. Future Initiatives</h2>
      <ul>
        <li>Providing educational resources on safe and responsible behavior.</li>
        <li>Enhancing automated content moderation and reporting mechanisms.</li>
        <li>Strengthening compliance with global child safety and privacy standards.</li>
      </ul>
      
      <p className="contact">For concerns or inquiries, contact us at heurekka@deebug.org.</p>
    </div>
  );
};

export default HeurekkaChildSafetyPolicy;
